import type { getOneOrderOutput } from "@/api/custom_types";
import { useTranslation } from "@/hooks";
import { getTimeSinceText } from "@/utils/timestamp";
import {
	type StatusTranslation,
	useOrderStatusTranslator,
} from "@/utils/translations";
import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
	Chip,
	type ChipVariant,
	Icon,
	Typography,
} from "@st-marketplace/ui";

const STATUS_COLOR_TO_CHIP_VARIANT: Record<
	StatusTranslation["color"],
	ChipVariant
> = {
	success: "success",
	primary: "info",
	error: "error",
	warning: "warning",
};

interface OrderDetailsInfoHistoryStatusProps {
	order: getOneOrderOutput;
}
function OrderDetailsInfoHistoryStatus({
	order,
}: OrderDetailsInfoHistoryStatusProps) {
	const { t, lang } = useTranslation();
	const translateStatus = useOrderStatusTranslator(t);

	return (
		<Card className="h-full border-secondary-border">
			<CardHeader>
				<div className="flex items-center gap-3">
					<Icon name="checkbox-circle-line" className="text-primary-100" />
					<CardTitle>
						<Typography variant="title-sm">
							{t("orderInfo.info.cardStatusHistoryTitle").toUpperCase()}
						</Typography>
					</CardTitle>
				</div>
			</CardHeader>
			<CardContent className="flex max-h-105 flex-col gap-5 overflow-y-auto">
				{[...order.status_history].reverse().map((item, index) => {
					const { color, text } = translateStatus(item.status);
					return (
						<div
							key={`${item.status}-${index}`}
							className="flex items-center justify-between"
						>
							<Chip variant={STATUS_COLOR_TO_CHIP_VARIANT[color]} size="sm">
								{text}
							</Chip>
							<Typography variant="body-sm">
								{getTimeSinceText(item.timestamp, t, lang)}
							</Typography>
						</div>
					);
				})}
			</CardContent>
		</Card>
	);
}

export default OrderDetailsInfoHistoryStatus;
